export default __webpack_public_path__ + "e9151e44c2f6e7f4e3c5634c5bed2647.svg";